export enum Format {
  PDF = 'PDF',
  DOCX = 'DOCX',
  XLSX = 'XLSX',
}
